module.exports = __webpack_public_path__ + "resources/img/ic-kor.9ccc938d.png";